/* Cart drawer, instant feel: + / - and the remove cross change the screen at once (quantity, line price, total, count, row collapse).
   The cart is then synced in the background, one request at a time, keyed by the line's key so a fast second tap can never hit the wrong item.
   When the last request returns, the drawer is redrawn from the server so every number is exact. */
(function () {
  if (window.__pmCartFast) return;
  window.__pmCartFast = 1;
  var queue = Promise.resolve(), pending = 0;

  function $(s, r) { return (r || document).querySelector(s); }
  function num(t) { var m = /([\d,]+\.\d{2})/.exec(t || ''); return m ? Math.round(parseFloat(m[1].replace(/,/g, '')) * 100) : null; }
  function put(t, c) { return t.replace(/[\d,]+\.\d{2}/, (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })); }
  function isPage(d) { return d.tagName === 'CART-ITEMS'; }
  function linePriceEls(li) { return [].slice.call(li.querySelectorAll(li.tagName === 'TR' ? '.price' : '.cart-item__totals .price')); }
  function lineSum(d) {
    var s = 0;
    [].forEach.call(d.querySelectorAll('.cart-item:not(.pmcf-gone)'), function (li) {
      var p = linePriceEls(li), el = p[p.length - 1], c = el ? num(el.textContent) : null;
      if (c != null) s += c;
    });
    return s;
  }
  function totalQty(d) {
    var n = 0;
    [].forEach.call(d.querySelectorAll('.cart-item:not(.pmcf-gone) input.quantity__input'), function (i) { n += parseInt(i.value, 10) || 0; });
    return n;
  }
  function setCounts(d, n) {
    var hc = $('.ipc-head__count', d); if (hc) hc.textContent = n + (n === 1 ? ' item' : ' items');
    [].forEach.call(document.querySelectorAll('#CartCount, .site-header__cart-count, .cart-count-bubble'), function (e) { e.textContent = n; });
  }

  function optimistic(d, li, newQty) {
    var inp = $('input.quantity__input', li), old = parseInt(inp.value, 10) || 1;
    var oldSum = lineSum(d);
    /* line price(s): scale by the new quantity */
    linePriceEls(li).concat([].slice.call(li.querySelectorAll('.cart-item__old-price'))).forEach(function (el) {
      var c = num(el.textContent);
      if (c != null && old > 0) el.textContent = put(el.textContent, Math.round(c / old * newQty));
    });
    inp.value = newQty;
    var plus = $('.qtyBtn[name="plus"]', li), max = parseInt(inp.getAttribute('max'), 10);
    if (plus && max) { if (newQty >= max) plus.setAttribute('aria-disabled', 'true'); else plus.removeAttribute('aria-disabled'); }
    if (newQty === 0) li.classList.add('pmcf-gone');
    var newSum = lineSum(d);
    /* total and checkout label follow the same ratio, so discounts stay in proportion until the server answers */
    if (isPage(d)) {
      var ft = $('#main-cart-footer');
      if (ft && oldSum > 0) {
        [].forEach.call(ft.querySelectorAll('*'), function (el) {
          if (el.children.length === 0 && /^\s*[^\d]*[\d,]+\.\d{2}[^\d]*$/.test(el.textContent) && !el.closest('.ipc-upsell,cart-upsell')) {
            var c = num(el.textContent); if (c != null) el.textContent = put(el.textContent, Math.round(c * newSum / oldSum));
          }
        });
        [].forEach.call(document.querySelectorAll('.ipc-cp-bar__btn, .ipc-cp-bar b'), function (el) {
          if (el.closest('#main-cart-footer')) return;
          [].forEach.call(el.childNodes, function (n) { if (n.nodeType === 3 && num(n.textContent) != null) n.textContent = put(n.textContent, Math.round(num(n.textContent) * newSum / oldSum)); });
        });
      }
    } else {
    var tot = $('.ipc-total-value', d), t0 = tot ? num(tot.textContent) : null;
    if (tot && t0 != null && oldSum > 0) {
      var t1 = Math.round(t0 * newSum / oldSum);
      tot.textContent = put(tot.textContent, t1);
      var co = $('#CartDrawer-Checkout', d);
      if (co) [].forEach.call(co.childNodes, function (n) { if (n.nodeType === 3 && num(n.textContent) != null) n.textContent = put(n.textContent, t1); });
    }
    }
    setCounts(d, totalQty(d));
    if (newQty === 0) {
      li.style.overflow = 'hidden'; li.style.maxHeight = li.offsetHeight + 'px';
      void li.offsetHeight;
      li.style.transition = 'max-height .24s ease, opacity .18s ease, margin .24s ease, padding .24s ease, transform .24s ease';
      li.style.maxHeight = '0'; li.style.opacity = '0'; li.style.marginTop = '0'; li.style.marginBottom = '0'; li.style.paddingTop = '0'; li.style.paddingBottom = '0'; li.style.transform = 'scale(.96)';
      setTimeout(function () { if (li.parentNode) li.parentNode.removeChild(li); }, 260);
    }
  }

  function redraw(d, html, count) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    if (isPage(d)) {
      var a = $('#main-cart-items .js-contents'), b = $('.js-contents', doc), fa = $('#main-cart-footer .cartTotal'), fb = $('.cartTotal', doc);
      if (a && b) a.innerHTML = b.innerHTML;
      if (fa && fb) fa.innerHTML = fb.innerHTML;
      d.classList.toggle('is-empty', count === 0);
      var ft = $('#main-cart-footer'); if (ft) ft.classList.toggle('is-empty', count === 0);
      setCounts(d, count);
      return;
    }
    var src = $('.drawer__inner', doc), dst = $('#CartDrawer .drawer__inner', d) || $('.drawer__inner', d);
    if (!src || !dst) return;
    var wallets = $('.ipc-dynamic-checkout', dst); /* keep the loaded wallet buttons, they are slow to start */
    dst.innerHTML = src.innerHTML;
    var fresh = $('.ipc-dynamic-checkout', dst);
    if (wallets && fresh && count > 0) fresh.parentNode.replaceChild(wallets, fresh);
    d.classList.toggle('is-empty', count === 0);
    dst.classList.toggle('is-empty', count === 0);
    setCounts(d, count);
  }

  function secId(d) { if (!isPage(d)) return 'cart-drawer'; var m = document.getElementById('main-cart-items'); return m ? m.getAttribute('data-id') : ''; }
  function sync(d, key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: secId(d), sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); });
  }

  function send(d, key, qty) {
    pending++;
    queue = queue.then(function () { return sync(d, key, qty); }).then(function (state) {
      pending--;
      var sid = secId(d);
      if (pending === 0 && state && state.sections && state.sections[sid]) redraw(d, state.sections[sid], state.item_count);
      else if (pending === 0) refresh(d);
    }).catch(function () { pending--; if (pending === 0) refresh(d); });
  }
  function refresh(d) {
    fetch('/cart?section_id=' + secId(d), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { redraw(d, html, c.item_count); });
    }).catch(function () { /* keep what is shown */ });
  }

  function ctx(el) { return el.closest('cart-drawer') || el.closest('cart-items'); }
  function act(e, li, newQty) {
    var d = li && ctx(li), key = li && li.getAttribute('data-key');
    if (!d || !key || newQty < 0) return false;
    e.preventDefault(); e.stopImmediatePropagation();
    optimistic(d, li, newQty);
    send(d, key, newQty);
    return true;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var rm = t.closest('cart-drawer cart-remove-button, cart-items cart-remove-button');
    if (rm) { act(e, rm.closest('.cart-item'), 0); return; }
    var b = t.closest('cart-drawer .qtyBtn, cart-items .qtyBtn');
    if (!b) return;
    var li = b.closest('.cart-item'), inp = li && $('input.quantity__input', li);
    if (!inp) return;
    if (b.getAttribute('aria-disabled') === 'true') { e.preventDefault(); e.stopImmediatePropagation(); return; }
    var n = (parseInt(inp.value, 10) || 0) + (b.getAttribute('name') === 'plus' ? 1 : -1), max = parseInt(inp.getAttribute('max'), 10);
    if (max && n > max) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    act(e, li, n);
  }, true);
})();
